export default __webpack_public_path__ + "static/tiktokLogo-66aeeb917131f850d7355d145830e911.png";